<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useSharedLabels from '~/composables/locale/useSharedLabels'
import { useVModel } from '@vueuse/core'

import Select from '~/ui/Select.vue'

interface Events {
  (e: 'update:modelValue', value: string): void
}

interface Props {
  modelValue: string
  all?: boolean
  label?: boolean
  empty?: boolean
  required?: boolean
  restrictTo?: string[] // TODO (wvffle): Make sure its string list
}

const emit = defineEmits<Events>()
const props = withDefaults(defineProps<Props>(), {
  all: false,
  label: false,
  empty: false,
  required: false,
  restrictTo: () => []
})

const value = useVModel(props, 'modelValue', emit)

const { t } = useI18n()
const sharedLabels = useSharedLabels()
const allChoices = sharedLabels.fields.report_type.choices

const categories = computed<[string, string][]>(() => [
  ...(props.all ? [['', t('components.moderation.ReportCategoryDropdown.option.all')] as [string, string]] : []),

  ...((props.restrictTo.length === 0 ?
    Object.keys(allChoices) : props.restrictTo) as string[])
    .sort()
    .map((key): [string, string] => [
      key,
      allChoices[key as keyof typeof allChoices] as string
    ])
])
</script>

<template>
  <Select
    v-bind="$attrs"
    :label="label ? t('components.moderation.ReportCategoryDropdown.label.category') : undefined"
    :options="categories"
    v-model="value"
  />
  <slot />
</template>
